import { URLs } from '../config'
import http from './http'
import { objectToFormdata } from './common'

export const senior = {
    get: {
        // @Url /v1/senior/{cbidx}
        senior: async(params) => {
            return await http.get(
                `${URLs.senior}/${params.cbidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/members/{cbidx}/overlap-check/{luidx}
        overlapCheck: async(params) => {
            return await http.get(
                `${URLs.members}/${params.cbidx}/overlap-check/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/senior/{cbidx}/{idx}
        seniorDetail: async(params) => {
            return await http.get(
                `${URLs.senior}/${params.cbidx}/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/senior/{cbidx}/memo/{idx}
        memo: async(params) => {
            return await http.get(
                `${URLs.senior}/${params.cbidx}/memo/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/senior/{cbidx}/dash
        dash: async(params) => {
            return await http.get(
                `${URLs.senior}/${params.cbidx}/dash`, { params: params }
            )
        },
        // @Url /v1/senior/{cbidx}/dash-senior-memo
        dashSeniorMemo: async(params) => {
            return await http.get(
                `${URLs.senior}/${params.cbidx}/dash-senior-memo`, { params: params }
            )
        },
        // @Url /v1/senior/{cbidx}/dash-regist-year
        dashRegistYear: async(params) => {
            return await http.get(
                `${URLs.senior}/${params.cbidx}/dash-regist-year`, { params: params }
            )
        },
        // @Url /v1/senior/{cbidx}/memo-inflow-list
        memoInflowList: async(params) => {
            return await http.get(
                `${URLs.senior}/${params.cbidx}/memo-inflow-list`, { params: params }
            )
        },
        // @Url /v1/senior/{cbidx}/judge-state
        judgeState: async(params) => {
            return await http.get(
                `${URLs.senior}/${params.cbidx}/judge-state`, { params: params }
            )
        },
        // @Url /v1/senior/{cbidx}/simple
        seniorSimple: async(params) => {
            return await http.get(
                `${URLs.senior}/${params.cbidx}/simple`, { params: params}
            )
        }
    },
    post: {
        // @Url /v1/senior/{cbidx}
        registSenior: async(params) => {
            return await http.post(
                `${URLs.senior}/${params.cbidx}`,
                params, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/senior/{cbidx}/{idx}
        updateSenior: async(params) => {
            return await http.post(
                `${URLs.senior}/${params.cbidx}/${params.idx}`,
                params, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/recipient/{cbidx}/profile-file/{idx}
        profileFile: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/profile-file/${params.idx}`, formData
            )
        },
        // @Url /v1/senior/{cbidx}/status
        status: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.senior}/${params.cbidx}/status`, formData
            )
        },
        // @Url /v1/senior/{cbidx}/memo/{idx}
        memo: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.senior}/${params.cbidx}/memo/${params.idx}`, formData
            )
        },
        // @Url /v1/senior/{cbidx}/memo/{idx}/{midx}
        updateMemo: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.senior}/${params.cbidx}/memo/${params.idx}/${params.midx}`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/charge-staff
        chargeStaff: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/charge-staff`, formData,
            )
        },
        // @Url /v1/senior/{cbidx}/senior-customer
        seniorCustomer: async(params) => {
            return await http.post(
                `${URLs.senior}/${params.cbidx}/senior-customer`,
                params, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/senior/{cbidx}/regist-ymd
        registYmd: async(params) => {
            return await http.post(
                `${URLs.senior}/${params.cbidx}/regist-ymd`,
                params.seniorRegistYmdDTO, {
                    params: {
                        luidx: params.luidx,
                        cbidx: params.cbidx
                    }
                }
            )
        },
    },
    delete: {
        // @Url /v1/senior/{cbidx}/{idx}
        aSenior: async(params) => {
            return await http.delete(
                `${URLs.senior}/${params.cbidx}/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/member/file-upload/{idx}
        fileUpload: async(params) => {
            return await http.delete(
                `${URLs.members}/file-upload/${params.idx}`
            )
        },
        // @Url /v1/senior/{cbidx}/memo/{idx}/{midx}
        memo: async(params) => {
            return await http.delete(
                `${URLs.senior}/${params.cbidx}/memo/${params.idx}/${params.midx}`, {
                    params: params
                }
            )
        },
    }
}


// WEBPACK FOOTER //
// ./src/api/seniors.js